<div class="se-history-card" [ngClass]="checked ? 'se-border-selected' : 'se-border-default'">
    <div class="se-image-preview-header-panel">

        <button mat-icon-button
                [style.visibility]="showLockIcon ? 'visible' : 'hidden'"
                matTooltip="{{ 'ImageKey_Blocked' | translate }}"
                matTooltipPosition="above"
                class="se-delete-icon se-button-no-ripple">
            <mat-icon>lock</mat-icon>
        </button>
        <div [style.visibility]="showEditIcon ? 'visible' : 'hidden'" class="mat-node-status node-icon-edit"
             matTooltip="{{ 'Edited' | translate }}"></div>
    </div>
    <div class="se-image-preview-panel">

        <img [style.visibility]="!showTextArea ? 'visible' : 'hidden'" [src]="imageSource" alt="Key Image" />


        <form [style.visibility]="showTextArea?'visible':'hidden'">
            <textarea [(ngModel)]="notesContent" (ngModelChange)="showEditIcon = true;emitSaveEvent()" name="nochecksContent"></textarea>
        </form>

    </div>
    <div class="se-history-expansion-panel">
        <div class="se-image-preview-footer-panel">
            <button *ngIf="checked"
                    mat-icon-button
                    [disabled]="showLockIcon"
                    (click)="clicked()"
                    matTooltip="{{ 'ImageKey_Included' | translate }}"
                    matTooltipPosition="above" class="se-button-no-ripple">
                <mat-icon>check_circle</mat-icon>
            </button>
            <button *ngIf="!checked"
                    mat-icon-button
                    [disabled]="showLockIcon"
                    (click)="clicked()"
                    matTooltip="{{ 'ImageKey_NotIncluded' | translate }}"
                    matTooltipPosition="above" class="se-button-no-ripple">
                <mat-icon>radio_button_unchecked</mat-icon>
            </button>
            <div class="se-col se-item-footer-controls">
                <button mat-icon-button
                        [disabled]="showLockIcon"
                        [color]="!showTextArea ? '' : 'primary'"
                        (click)="editNotes()"
                        class="se-delete-icon se-button-no-ripple">
                    <mat-icon matTooltip="{{ 'Modify' | translate }}"
                              matTooltipPosition="above">edit</mat-icon>
                </button>
                <button (click)="deleteCard()" mat-icon-button class="se-delete-icon se-button-no-ripple" [disabled]="showLockIcon">
                    <mat-icon matTooltip="{{ 'ImageKey_Delete' | translate }}"
                              matTooltipPosition="above">delete</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
